import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { DashboardTile } from 'src/app/pages/dashboard/models/dashboard-tile.model';

@Component({
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-fallback-tile',
    templateUrl: './fallback-tile.component.html',
    styleUrls: ['./fallback-tile.component.scss'],
    host: {
        class: 'fallback-tile-wrapper',
    },
    standalone: false
})
export class FallbackTileComponent {
   @Input() tileConfig: DashboardTile;

   constructor(public changeDetectorRef: ChangeDetectorRef) {}
}
